import { IGetUserDataByRequestResponse } from 'shared/repositories/monolith-python/v1/get-user-data-by-request';
import { TUser } from 'shared/types/user';

export const prepareUser = ({ data: { user } }: IGetUserDataByRequestResponse): TUser => {
  if (!user || !user.userId) {
    return { isAuthenticated: false };
  }

  return user;
};
